/**
 * DevExtreme (esm/__internal/grids/new/grid_core/inferno_wrappers/form.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import dxForm from "../../../../../ui/form";
import {
    InfernoWrapper
} from "./widget_wrapper";
export class Form extends InfernoWrapper {
    getComponentFabric() {
        return dxForm
    }
}
